import { useEffect, useMemo } from 'react';
import { create } from 'zustand';
// $TODO: Figure out what kind of global events are needed and move these to
// the appropriate context
var useWindowSizeStore = create(function (set) { return ({
    /**
     * Initial state is set to 0 here initially to avoid immediate [reflow](https://gist.github.com/paulirish/5d52fb081b3570c81e3a),
     * a common performance bottleneck when requesting/calling certain properties or methods that trigger synchronous style/layout calculations.
     */
    windowSize: { width: 0, height: 0 },
    setWindowSize: function (windowSize) { return set({ windowSize: windowSize }); },
}); });
export var useSingletonWindowSize = function () {
    var windowStore = useWindowSizeStore();
    useEffect(function () {
        // Handler to call on window resize
        var handleResize = function () {
            // Set window width/height to state
            windowStore.setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        };
        // Add event listener
        window.addEventListener('resize', handleResize);
        // Call handler right away so state gets updated with initial window size
        handleResize();
        // Remove event listener on cleanup
        return function () { return window.removeEventListener('resize', handleResize); };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // Empty array ensures that effect is only run on mount
    return useMemo(function () { return windowStore.windowSize; }, [windowStore.windowSize]);
};
//# sourceMappingURL=useSingletonWindowSize.js.map